// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { FieldsFactory } from '../Factory/FieldsFactory';
import { Message } from '@shared/utils/DirectMessages/Message';
import { PFixMessage } from './PFixMessage';
export class OrderReplaceMessage extends PFixMessage {
    constructor(fieldSet) {
        super(Message.CODE_REPLACE_ORDER_MESSAGE, fieldSet);
    }
    getOrderId() {
        return this.getFieldValue(FieldsFactory.FIELD_ORDER_ID);
    }
    setOrderId(orderId) {
        this.setFieldValue(FieldsFactory.FIELD_ORDER_ID, orderId);
    }
    getComment() {
        return this.getFieldValue(FieldsFactory.FIELD_COMMENT);
    }
    setComment(comment) {
        this.setFieldValue(FieldsFactory.FIELD_COMMENT, comment);
    }
    getUserComment() {
        return this.getFieldValue(FieldsFactory.FIELD_USER_COMMENT);
    }
    setUserComment(comment) {
        this.setFieldValue(FieldsFactory.FIELD_USER_COMMENT, comment);
    }
    getOrderType() {
        return this.getFieldValue(FieldsFactory.FIELD_ORDER_TYPE);
    }
    setOrderType(type) {
        this.setFieldValue(FieldsFactory.FIELD_ORDER_TYPE, type);
    }
    getOperationType() {
        return this.getFieldValue(FieldsFactory.FIELD_OPERATION_TYPE);
    }
    setOperationType(type) {
        this.setFieldValue(FieldsFactory.FIELD_OPERATION_TYPE, type);
    }
    getPrice() {
        return this.getFieldValue(FieldsFactory.FIELD_PRICE);
    }
    setPrice(price) {
        this.setFieldValue(FieldsFactory.FIELD_PRICE, price);
    }
    getStopPrice() {
        return this.getFieldValue(FieldsFactory.FIELD_STOP_PRICE);
    }
    setStopPrice(price) {
        this.setFieldValue(FieldsFactory.FIELD_STOP_PRICE, price);
    }
    setTIFExpireDate(time) {
        this.setFieldValue(FieldsFactory.FIELD_EXPIRE_AT, time);
    }
    getAmount() {
        return this.getFieldValue(FieldsFactory.FIELD_AMOUNT);
    }
    setAmount(amount) {
        this.setFieldValue(FieldsFactory.FIELD_AMOUNT, amount);
    }
    getDisclosedQty() {
        return this.getFieldValue(FieldsFactory.FIELD_DISCLOSED_QUANTITY);
    }
    setDisclosedQty(disclosedQty) {
        this.setFieldValue(FieldsFactory.FIELD_DISCLOSED_QUANTITY, disclosedQty);
    }
    getValidity() {
        return this.getFieldValue(FieldsFactory.FIELD_VALIDITY);
    }
    setValidity(validity) {
        this.setFieldValue(FieldsFactory.FIELD_VALIDITY, validity);
    }
    getOnBehalfId() {
        return this.getFieldValue(FieldsFactory.FIELD_ON_BEHALF_USER_ID);
    }
    setOnBehalfId(onBehalfId) {
        this.setFieldValue(FieldsFactory.FIELD_ON_BEHALF_USER_ID, onBehalfId);
    }
    getBoundTo() {
        return this.getFieldValue(FieldsFactory.FIELD_BOUNDTOORDERID);
    }
    setBoundTo(id) {
        this.setFieldValue(FieldsFactory.FIELD_BOUNDTOORDERID, id);
    }
    getInstrumentId() {
        return this.getFieldValue(FieldsFactory.FIELD_INSTRUMENT_ID);
    }
    setInstrumentId(id) {
        this.setFieldValue(FieldsFactory.FIELD_INSTRUMENT_ID, id);
    }
    getInstrumentTradableID() {
        return this.getFieldValue(FieldsFactory.FIELD_TRADABLE_INSTRUMENT_ID);
    }
    setInstrumentTradableID(id) {
        this.setFieldValue(FieldsFactory.FIELD_TRADABLE_INSTRUMENT_ID, id);
    }
    getRouteId() {
        return this.getFieldValue(FieldsFactory.FIELD_ROUTE_ID);
    }
    setRouteId(id) {
        this.setFieldValue(FieldsFactory.FIELD_ROUTE_ID, id);
    }
    getAccountId() {
        return this.getFieldValue(FieldsFactory.FIELD_ACCOUNT_ID);
    }
    setAccountId(id) {
        this.setFieldValue(FieldsFactory.FIELD_ACCOUNT_ID, id);
    }
    getProductType() {
        return this.getFieldValue(FieldsFactory.FIELD_PRODUCT_TYPE);
    }
    setProductType(type) {
        this.setFieldValue(FieldsFactory.FIELD_PRODUCT_TYPE, type);
    }
    setPowerOfAttorneyUserId(userId) {
        this.setFieldValue(FieldsFactory.FIELD_POA_USER_ID, userId);
    }
    setReceivedBy(receivedBy) {
        this.setFieldValue(FieldsFactory.FIELD_ORDER_RECEIVED_BY, receivedBy);
    }
    setPlacedFrom(placedFrom) {
        this.setFieldValue(FieldsFactory.FIELD_CLIENT_PANEL, placedFrom);
    }
    setSLLimitPrice(price) {
        this.setFieldValue(FieldsFactory.FIELD_SL_LIMIT_PRICE, price);
    }
    setSLTriggerPrice(price) {
        this.setFieldValue(FieldsFactory.FIELD_SL_TRIGGER_PRICE, price);
    }
    setTPTriggerPrice(price) {
        this.setFieldValue(FieldsFactory.FIELD_TP_TRIGGER_PRICE, price);
    }
    setSLTPTriggerPrice(price) {
        this.setFieldValue(FieldsFactory.FIELD_SL_TP_TRIGGER_PRICE, price);
    }
}
